/**
 * @Description
 */

import { FC, useState } from 'react';
import { Tooltip } from 'antd';
import cs from 'classnames';
import styles from './index.module.less';
import PickFolderModal from '../CollectDrawer/PickFolderModal';
import { useBigdataFn } from '@/common/utils/bigdata';
import IconFont from '@/common/components/IconFont';

const Entrance: FC<any> = ({
  eventName = '', // 埋点 op_event
  clusterId, // 商圈ID
  spotId, // 点位ID
  collectStatus, // 是否已收藏
  setCollectStatus, // 更新收藏/取消收藏状态
  eventId, // 埋点事件id
  wrapperClassName,
  iconClassName,
  isLarge,
  // rankSort, // 前xx名
  // setItemData, // 设置当前选中项
  collectEventFn = () => {}, // 埋点方法
  updateFavoriteClusterIds,
  modelConfigId
}) => {
  const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const [open, setOpen] = useState(false);

  return (
    <div className={styles.spaceCon} onClick={(e) => { e.stopPropagation(); }}>
      <Tooltip title={collectStatus ? '已收藏' : '收藏'}>
        <div className={cs(styles.favoriteBtnWrapper, wrapperClassName, isLarge ? styles.isLarge : '')} onClick={() => {
          if (eventId) {
            bigdataFn(eventId, '收藏', '点击了收藏', { op_block: '开店区域', op_event: eventName || null, });
          }
          collectEventFn?.();
          setOpen(true);
        }}>
          {
            collectStatus
              ? <IconFont iconHref={'iconic_shoucang11'} className={cs('fs-12', styles.starIcon, styles.active, iconClassName)}/>
              : <IconFont iconHref={'iconic_shoucang2'}
                className={cs('fs-12', styles.starIcon, iconClassName)}/>
          }
        </div>
      </Tooltip>
      {/* 收藏/取消收藏弹窗 */}
      <PickFolderModal
        open={open}
        clusterId={clusterId}
        spotId={spotId}
        // build={!collectStatus}
        setOpen={setOpen}
        setCollectStatus={setCollectStatus}
        updateFavoriteClusterIds={updateFavoriteClusterIds}
        modelConfigId={modelConfigId}
      />
    </div>
  );
};

export default Entrance;
